(function () {
  if (window.customElements.get('collection-infinite-scroll')) return;

  class CollectionInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.collection = this.closest('.collection');
      this.productList = this.collection && this.collection.querySelector('product-list');
      this.pagination = this.querySelector('.pagination');
      this.sentinel = this.querySelector('[data-infinite-scroll-sentinel]');
      this.spinner = this.querySelector('[data-infinite-scroll-spinner]');
      this.nextLink = this.querySelector('a.pagination__item[rel="next"]');

      if (!this.productList || !this.sentinel || !this.nextLink) return;

      this.loading = false;
      this.classList.add('is-active');

      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        rootMargin: '600px 0px'
      });
      this.observer.observe(this.sentinel);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    onIntersect(entries) {
      if (entries[0] && entries[0].isIntersecting) this.loadNext();
    }

    async loadNext() {
      if (this.loading || !this.nextLink) return;

      const section = this.closest('.shopify-section');
      if (!section) return;

      this.loading = true;
      this.setBusy(true);

      const sectionId = section.id.replace('shopify-section-', '');
      const url = new URL(this.nextLink.href, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      try {
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error('Failed to load products');

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incomingList = doc.querySelector('product-list');
        const incomingNav = doc.querySelector('collection-infinite-scroll .pagination') || doc.querySelector('.collection__pagination');

        if (incomingList) {
          Array.from(incomingList.children).forEach(function (node) {
            if (node.classList && node.classList.contains('product-list__promo')) return;
            this.productList.appendChild(document.importNode(node, true));
          }, this);
        }

        const newNext = incomingNav && incomingNav.querySelector('a.pagination__item[rel="next"]');
        const incomingCurrent = incomingNav && incomingNav.querySelector('.pagination__current');
        const localCurrent = this.querySelector('.pagination__current');
        if (incomingCurrent && localCurrent) {
          localCurrent.innerHTML = incomingCurrent.innerHTML;
        }

        if (newNext) {
          this.nextLink.href = newNext.getAttribute('href');
        } else {
          this.nextLink = null;
          if (this.observer) this.observer.disconnect();
          if (this.pagination) this.pagination.setAttribute('hidden', '');
        }
      } catch (error) {
        this.classList.remove('is-active');
        if (this.observer) this.observer.disconnect();
      } finally {
        this.loading = false;
        this.setBusy(false);
      }
    }

    setBusy(busy) {
      this.productList.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (this.spinner) this.spinner.hidden = !busy;
    }
  }

  window.customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
})();
